import React, { useState, useEffect } from 'react';
import { getAdminTransfers, updateTransferStatus, adminDeleteTransfer } from '../services/api';

function Admin() {
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTransfers();
  }, []);

  const loadTransfers = async () => {
    try {
      const res = await getAdminTransfers();
      setTransfers(res.data);
    } catch (err) {
      console.error('加载失败', err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStatus = async (id, status) => {
    try {
      await updateTransferStatus(id, status);
      loadTransfers();
    } catch (err) {
      console.error('更新失败', err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('确定要删除这条信息吗？')) return;
    try {
      await adminDeleteTransfer(id);
      loadTransfers();
    } catch (err) {
      console.error('删除失败', err);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold">后台管理</h2>
      </div>

      {loading ? (
        <div className="text-center py-8">加载中...</div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">类型</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">发布人</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">当前</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">目标</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">状态</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">操作</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {transfers.map(t => (
                  <tr key={t.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{t.id}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${t.type === '对调' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                        {t.type}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{t.username}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      <div>{t.current_bureau}局</div>
                      <div className="text-gray-500 text-xs">{t.current_unit}</div>
                      {t.current_workshop && <div className="text-gray-400 text-xs">{t.current_workshop}</div>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      <div>{t.target_bureau}局</div>
                      <div className="text-gray-500 text-xs">{t.target_unit}</div>
                      {t.target_workshop && <div className="text-gray-400 text-xs">{t.target_workshop}</div>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${t.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
                        {t.status === 'active' ? '发布中' : '已下架'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex gap-2">
                        {t.status === 'active' ? (
                          <button
                            onClick={() => handleUpdateStatus(t.id, 'inactive')}
                            className="text-yellow-600 hover:text-yellow-900"
                          >
                            下架
                          </button>
                        ) : (
                          <button
                            onClick={() => handleUpdateStatus(t.id, 'active')}
                            className="text-green-600 hover:text-green-900"
                          >
                            上架
                          </button>
                        )}
                        <button
                          onClick={() => handleDelete(t.id)}
                          className="text-red-600 hover:text-red-900"
                        >
                          删除
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {transfers.length === 0 && (
            <div className="text-center py-12 text-gray-500">
              暂无信息
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Admin;
